import React, { useEffect, useState, useRef } from 'react'
import Layout from '../../../components/layout/Layout'
import { useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { sendData } from '../../../store/actions'
import * as Icon from 'ubs-icons';
import Validator from 'simple-react-validator'
import {useForceUpdate} from "ubs-framework/v2/hooks/useForceUpdate";
import {checkLowercase, checkMinLength, checkNumeric, checkSpecialCharacter, checkUppercase, isMobileDevice,} from 'ubs-framework/v2/common/function';
import {createCookie, eraseCookie} from 'ubs-framework/v2/common/function';
import useSocket from '../../common/useSocket'
import AppHeader from '../../common/components/app-header'
import UInput from "ubs-framework/v2/UInput"
import UPopup from "ubs-framework/v2/UPopup";
import Commonrightcircle from '../../../common/component/RightCircle/commonrightcircle'
import {COLOR, constant, REGEX} from '../../../common/constant'
import {showToastSuccess} from "ubs-framework/v2/common/function";
import LayoutV2 from '../../../components/layout-v2'

import { TEST_ID } from "ubs-framework/v2/test-ids/account-testids";

function ChangePassword() {
    const dispatch = useDispatch()
    const history = useHistory()

    const _EMAIL = useSelector(e => e.common?.email)
    const _EC = useSelector(e => e.common?.employeeCode)

    const [errorMsg, setErrorMsg] = useState('')
    const [disabledBtn, setDisabledBtn] = useState(false)
    const [resetDetail, setResetDetail] = useState({
        oldPassword: '',
        newPassword: '',
        cPassword: '',
    })
    const [passwordEye, setPasswordEye] = useState(false)
    const [currPassword, setCurrPassword] = useState(false)
    const [hide, setHide] = useState(false)
    const forceUpdate = useForceUpdate()
    const validator = useRef(new Validator({
        element: (message, className) => <div className="u_error_message">{message}</div>,
        autoForceUpdate: { forceUpdate },
        validators: {
            uppercase: {  // name the rule
                message: 'Please use uppercase.',
                rule: (val, params, validator) => {
                    return validator.helpers.testRegex(val, REGEX.upperCase) && params.indexOf(val) === -1
                },
            },
            lowercase: {  // name the rule
                message: 'Please use lowercase.',
                rule: (val, params, validator) => {
                    return validator.helpers.testRegex(val, REGEX.lowerCase) && params.indexOf(val) === -1
                },
            },
            specialcase: {  // name the rule
                message: 'Please use one special character.',
                rule: (val, params, validator) => {
                    return validator.helpers.testRegex(val, REGEX.specialChar) && params.indexOf(val) === -1
                },
            },
            number: {  // name the rule
                message: 'Please use one number.',
                rule: (val, params, validator) => {
                    return validator.helpers.testRegex(val, REGEX.number) && params.indexOf(val) === -1
                },
            },
        },
    }))


    const { on, off, refresh } = useSocket(res => {
        setDisabledBtn(false)
        if (!res.error) {
            switch (res.event) {
                case 'hrms|myPassword|update':
                    createCookie('ubs_token', res.data.token, constant.COOKIE_DAYS)
                    showToastSuccess('Password updated successfully.')
                    history.push('/workspace')
                    break
                default:
                    return true
            }
        } else {
            setErrorMsg(res.data.error)
            setTimeout(() => setErrorMsg(res.data.error), 5000)
        }
    })

    const inputEvent = (e) => {
        let { name, value } = e.target
        value = value.replace(/^\s+/g, '').trim()
        setResetDetail((val) => {
            return { ...val, [name]: value }
        })
    }

    useEffect(() => {
        on()
        return () => off()
    }, [])

    const onSubmit = obj => {
        if (validator?.current?.allValid()) {
            if (resetDetail?.cPassword !== resetDetail?.newPassword) {
                setErrorMsg('Password and confirm password does not match')
            } else {
                const data = {
                    oldPassword: resetDetail.oldPassword,
                    newPassword: resetDetail.newPassword
                }
                sendData(dispatch, 'hrms|myPassword|update', data)
                setDisabledBtn(true)
            }
        } else {
            validator?.current?.showMessages()
        }
    }

    const onKeyUp = (e) => {
        if (e.key === 'Enter') {
            onSubmit(e)
        }
    }
    const cancel = () => {
        if (localStorage.getItem('notification_token')) sendData('logout', {device_token: localStorage.getItem('notification_token')})
        dispatch({type: 'LOGOUT'});
        localStorage.clear()
        eraseCookie('ubs_token')
        eraseCookie('ubsTabId')
        history.push('/login')
        window.location.reload(true)
    }

    return (
        <React.Fragment>
            <LayoutV2 module="emailsent">
                <div className="u_p-24">

                    <div className="u_text-center u_mb-24">
                        <h3 className="u_title u_text-bold u_mb-12">Change Password</h3>
                        <p className="u_small-font">To create your new password, provide the following information, and then click change password button.</p>
                    </div>

                    {_EMAIL && _EMAIL?.length !== 0 && <UInput
                        hasError={''}
                        className="u_mb-20"
                        label="Email Address"
                        asterisk
                        testId={TEST_ID.CHANGE_FIRST_PASSWORD.INPUT_WRAPPER}>
                        <input
                            value={_EMAIL}
                            type="text"
                            name="Email"
                            placeholder=" "
                            disabled={true}
                            data-testid={TEST_ID.CHANGE_FIRST_PASSWORD.EMAIL_INPUT} />
                    </UInput>}
                    {_EC && _EC?.length !== 0 && <UInput
                        hasError={''}
                        className="u_mb-20"
                        label="Employee Code"
                        asterisk
                        testId={TEST_ID.CHANGE_FIRST_PASSWORD.INPUT_WRAPPER}>
                        <input
                            value={_EC}
                            type="text"
                            name="Employee Code"
                            placeholder=" "
                            disabled={true}
                            data-testid={TEST_ID.CHANGE_FIRST_PASSWORD.EMPLOYEE_CODE_INPUT} />
                    </UInput>}

                    <UInput
                        label="Current Password"
                        className="u_mb-20"
                        hasError={validator.current.message('oldPassword', resetDetail?.oldPassword, 'required')}
                        asterisk
                        testId={TEST_ID.CHANGE_FIRST_PASSWORD.INPUT_WRAPPER}>
                        <input
                            type={`${currPassword ? 'text' : 'password'}`}
                            name="oldPassword"
                            placeholder=" "
                            value={resetDetail?.oldPassword}
                            onChange={inputEvent}
                            onKeyUp={onKeyUp}
                            autoComplete="off"
                            data-testid={TEST_ID.CHANGE_FIRST_PASSWORD.OLD_PASSWORD_INPUT} />
                        <div className="u_input-note u_ib">
                            <UPopup params={{ className: 'u_tooltip u_tooltip-full', disabled: isMobileDevice() }}
                                    desc={<span>{!currPassword ? 'Show Password' : 'Hide Password'} </span>}>
                                <span className="u_rollover u_cp u_flex"
                                      onClick={() => setCurrPassword(!currPassword)} >{!currPassword ?
                                    <Icon.HideEye size={18} fill={COLOR.u_icon_bg}/> :
                                    <Icon.Eye size={18} fill={COLOR.u_icon_bg}/>}</span>
                            </UPopup></div>
                    </UInput>

                    <UInput
                        className="u_mb-20"
                        label="New Password"
                        password
                        asterisk
                        hasError={validator?.current?.message('newPassword', resetDetail?.newPassword, 'required|min:8|uppercase|lowercase|specialcase|number')}
                        testId={TEST_ID.CHANGE_FIRST_PASSWORD.INPUT_WRAPPER}>
                        <input
                            onChange={inputEvent}
                            value={resetDetail?.newPassword}
                            name="newPassword"
                            onKeyUp={onKeyUp}
                            type={`${passwordEye ? 'text' : 'password'}`}
                            autoComplete="off"
                            placeholder=" "
                            data-testid={TEST_ID.CHANGE_FIRST_PASSWORD.NEW_PASSWORD_INPUT} />
                        <div className="u_input-note u_ib">
                            <UPopup params={{ className: 'u_tooltip u_tooltip-full', disabled: isMobileDevice() }}
                                    desc={<span>{!passwordEye ? 'Show Password' : 'Hide Password'} </span>}>
                                <span className="u_rollover u_cp u_flex"
                                      onClick={() => setPasswordEye(!passwordEye)} >{!passwordEye ?
                                    <Icon.HideEye size={18} fill={COLOR.u_icon_bg}/> :
                                    <Icon.Eye size={18} fill={COLOR.u_icon_bg}/>}</span>
                            </UPopup></div>
                    </UInput>

                    <UInput
                        className="u_mb-20"
                        label="Confirm Password"
                        password
                        asterisk
                        hasError={validator?.current?.message('', resetDetail?.cPassword, 'required|min:8|uppercase|lowercase|specialcase|number')}
                        testId={TEST_ID.CHANGE_FIRST_PASSWORD.INPUT_WRAPPER}>
                        <input
                            onChange={inputEvent}
                            value={resetDetail?.cPassword}
                            name="cPassword"
                            onKeyUp={onKeyUp}
                            type={`${hide ? 'text' : 'password'}`}
                            autoComplete="off"
                            placeholder=" "
                            data-testid={TEST_ID.CHANGE_FIRST_PASSWORD.CONFIRM_PASSWORD_INPUT} />
                        <div className="u_input-note u_ib">
                            <UPopup params={{ className: 'u_tooltip u_tooltip-full', disabled: isMobileDevice() }}
                                    desc={<span>{!hide ? 'Show Password' : 'Hide Password'} </span>}>

                                <span className="u_rollover u_cp u_flex" onClick={() => setHide(!hide)} >{!hide ?
                                    <Icon.HideEye size={18} fill={COLOR.u_icon_bg}/> :
                                    <Icon.Eye size={18} fill={COLOR.u_icon_bg}/>}</span>
                            </UPopup>
                        </div>
                    </UInput>

                    <div className={`u_reset-content ${errorMsg ? 'u_mb-0' : 'u_mb-10'}`}>
                        <ul className="u_flex u_flex-wrap">
                            <li style={{ color: `${checkMinLength(resetDetail.newPassword, 8) ? '#60B158' : '#8F95A6'}` }}>
                                <Icon.DoubleTick size={18} className="u_mr-10 u_ib u_align-middle" fill={`${checkMinLength(resetDetail.newPassword, 8) ? '#60B158' : '#8F95A6'} `}/>Minimum
                                8 Characters
                            </li>
                            <li style={{ color: `${checkUppercase(resetDetail.newPassword) ? '#60B158' : '#8F95A6'} ` }}>
                                <Icon.DoubleTick size={18} className="u_mr-10 u_ib u_align-middle" fill={`${checkUppercase(resetDetail.newPassword) ? '#60B158' : '#8F95A6'} `}/>Uppercase
                            </li>
                            <li style={{ color: `${checkLowercase(resetDetail.newPassword) ? '#60B158' : '#8F95A6'} ` }}>
                                <Icon.DoubleTick size={18} className="u_mr-10 u_ib u_align-middle" fill={`${checkLowercase(resetDetail.newPassword) ? '#60B158' : '#8F95A6'} `}/>Lowercase
                            </li>
                            <li style={{ color: `${checkNumeric(resetDetail.newPassword) ? '#60B158' : '#8F95A6'} ` }}>
                                <Icon.DoubleTick size={18} className="u_mr-10 u_ib u_align-middle" fill={`${checkNumeric(resetDetail.newPassword) ? '#60B158' : '#8F95A6'} `}/>1
                                Numeric Number
                            </li>
                            <li style={{ color: `${checkSpecialCharacter(resetDetail.newPassword) ? '#60B158' : '#8F95A6'} ` }}>
                                <Icon.DoubleTick size={18} className="u_mr-10 u_ib u_align-middle" fill={`${checkSpecialCharacter(resetDetail.newPassword) ? '#60B158' : '#8F95A6'} `}/>1
                                Special Character
                            </li>
                        </ul>
                    </div>
                    {errorMsg.length !== 0 && <p className="u_error-message u_mb-10">{errorMsg}</p>}

                    <div className="u_flex u_content-between">
                        <button
                            disabled={disabledBtn}
                            type="button"
                            onClick={() => cancel()}
                            className="u_btn u_btn__white u_w-full u_cp"
                            data-testid={TEST_ID.CHANGE_FIRST_PASSWORD.CHANGE_PASSWORD_BUTTON}>Cancel
                        </button>
                        <button
                            disabled={disabledBtn}
                            type="button"
                            onClick={onSubmit}
                            className="u_btn u_btn__blue u_w-full u_cp"
                            data-testid={TEST_ID.CHANGE_FIRST_PASSWORD.CHANGE_PASSWORD_BUTTON}>Change Password
                        </button>
                    </div>
                </div>
            </LayoutV2>
        </React.Fragment>
    );
}


export default ChangePassword

